<template>
  <div class="page">
    <f7-navbar title="課輔媒合" back-link="Back" @click="backIndex()">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="page-content">
      <header class="wave-header sticky-top"></header>
      <p class="segmented segmented-round">
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':progressActive}" v-on:click="changeButton('progress')">申請中</button>
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':checkActive}" v-on:click="changeButton('checking')">審核中</button>
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':approvedActive}" v-on:click="changeButton('approved')">審核通過</button>
    </p>

    <div id="progress" v-if="progressActive">
      <div class="list">
        <ul v-if="!progressLoading">
          <li v-for="(item,index) in progressData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.courseName }}
                  <div class="item-footer sub-content">
                    <span>{{ item.classAt.toString().split("T")[0] }}</span>
                    <span class="hours">{{ item.classHours }}</span>
                  </div>
                </div>
                <div class="item-after dollar">+ {{ item.allowHours }} T</div>
              </div>
            </a>
          </li>
          <template v-if="progressData.length === 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
            </div> 
          </template>
        </ul>
      </div>
      
      <!--
         <div class="list">
          <ul>
            <li>
              <a href="#" class="item-content">
                <div class="item-inner">
                  <div class="item-title">
                    必修-普通物理
                    <div class="item-footer sub-content">
                      <span>2019-01-01</span>
                      <span class="hours">10 hrs</span>
                    </div>
                  </div>
                  <div class="item-after dollar">+ 1,000 點</div>
                </div>
              </a>
            </li>
            <li>
              <a href="#" class="item-content">
                <div class="item-inner">
                  <div class="item-title">
                    必修-邏輯設計
                    <div class="item-footer sub-content">
                      <span>2019-01-01</span>
                      <span class="hours">10 hrs</span>
                    </div>
                  </div>
                  <div class="item-after dollar">+ 1,000 點</div>
                </div>
              </a>
            </li>
          </ul>
        </div>

    <div class="list">
      <div class="block-header">學年度第學期</div>
      <ul>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title">
                必修-機率統計
                <div class="item-footer sub-content">
                  <span>2019-01-01</span>
                  <span class="hours">10 hrs</span>
                </div>
              </div>
              <div class="item-after dollar">+ 1,000 Ｔ</div>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title">
                電機基礎概論
                <div class="item-footer sub-content">
                  <span>2019-01-01</span>
                  <span class="hours">10 hrs</span>
                </div>
              </div>
              <div class="item-after dollar">+ 1,000 Ｔ</div>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="list">
      <div class="block-header"> 學年度第 學期</div>
      <ul>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title">
                電機基礎概論
                <div class="item-footer sub-content">
                  <span>2019-01-01</span>
                  <span class="hours">10 hrs</span>
                </div>
              </div>
              <div class="item-after dollar">+ 1,000 Ｔ</div>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title">
                電機基礎概論
                <div class="item-footer sub-content">
                  <span>2019-01-01</span>
                  <span class="hours">10 hrs</span>
                </div>
              </div>
              <div class="item-after dollar">+ 1,000 Ｔ</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    -->
    </div>

    <div id="checking" v-if="checkActive">
      <div class="list">
        <ul v-if="!checkLoading">
          <li v-for="(item,index) in checkData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.courseName }}
                  <div class="item-footer sub-content">
                    <span>{{ item.classAt.toString().split("T")[0] }}</span>
                    <span class="hours">{{ item.classHours }}</span>
                  </div>
                </div>
                <div class="item-after dollar">+ {{ item.allowHours }} 點</div>
              </div>
            </a>
          </li>
          <template v-if="checkData.length == 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
            </div> 
          </template>
        </ul>
      </div>


    </div>
      <div id="Approved" v-if="approvedActive">
        <div class="list">
        <ul v-if="!approvedLoading">
          <li v-for="(item,index) in approvedData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.courseName }}
                  <div class="item-footer sub-content">
                    <span>{{ item.classAt.toString().split("T")[0] }}</span>
                    <span class="hours">{{ item.classHours }}</span>
                  </div>
                </div>
                <div class="item-after dollar">+ {{ item.allowHours }} 點</div>
              </div>
            </a>
          </li>
          <template v-if="approvedData.length == 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
             </div> 
          </template>
        </ul>
      </div>

      </div>
    </div>
    <div class="fab fab-right-bottom">
      <a href="#">
        <i class="icon material-icons">add</i>
        <i class="icon material-icons">close</i>
      </a>
      <div class="fab-buttons fab-buttons-top">
        <template v-if="$store.state.coachType==10">
          <a href="/teaching1" class="fab-label">我的教課資訊</a>
        </template>
        <template v-else>
          <a href="/search" class="fab-label">申請輔導</a>
        </template>
      </div>
    </div>
  </div>
  
</template>

<script>
import Service from "../../service";
import axios from '../../js/axiosModule';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      progressData:[],
      progressLoading:false,
      progressActive:true,
      checkData:[],
      checkLoading:false,
      checkActive:false,
      approvedData:[],
      approvedLoading:false,
      approvedActive:false
    };
  },
  created: function() {},
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    getCoachClassRecord :function() {
      let self = this;
      self.progressLoading = true;
      self.checkLoading = true;
      self.approvedLoading = true;
      var params={};
      params.queryType="tutor";
      params.queryString=self.$store.state.userInfo.studentNo;
      params.minStatus=10;
      params.maxStatus=10;
      params.takeRowCount=0;
      params.startAt=self.getHalfTime();
      params.endAt=self.getNowTime();
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachClassRecords",params).then((response)=> {
        self.progressData = response.data.data; 
        self.progressLoading = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });

      params={};
      params.queryType="tutor";
      params.queryString=self.$store.state.userInfo.studentNo;
      params.minStatus=30;
      params.maxStatus=30;
      params.takeRowCount=0;
      params.startAt=self.getHalfTime();
      params.endAt=self.getNowTime();
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachClassRecords",params).then((response)=> {
        self.checkData = response.data.data; 
        self.checkLoading=false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });

       params={};
      params.queryType="tutor";
      params.queryString=self.$store.state.userInfo.studentNo;
      params.minStatus=60;
      params.maxStatus=60;
      params.takeRowCount=0;
      params.startAt=self.getHalfTime();
      params.endAt=self.getNowTime();
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachClassRecords",params).then((response)=> {
        self.approvedData = response.data.data; 
        self.approvedLoading = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    },changeButton : function(objType) {
      let self = this;
      if( objType === "progress" ) {
        self.progressActive = true;
        self.checkActive = false;
        self.approvedActive = false;
      } else if ( objType === "checking" ) {
        self.progressActive = false;
        self.checkActive = true;
        self.approvedActive = false;
      } else if ( objType === "approved" ) {
        self.progressActive = false;
        self.checkActive = false;
        self.approvedActive = true;
      }
    },
    getHalfTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss").month(1)._d;
      return dateTime;
    },
     getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    },
    backIndex:function() {
      this.$f7router.navigate("/" );
    },
  },mounted() {
    let self = this;
    self.getCoachClassRecord();
  },
  computed: {
    computedDate: function(date) {
      return date.split("T")[0]
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/my-coin/coin-detail.vue